const CONSTANTS = {
  LOCALSTORAGE_KEYS: {
    PLAYBACK_SPEED: 'playbackSpeed',
    VIDEO_PANEL_SPLIT_PERCENTAGE: 'videoPanelSplitPercentage',  
    DISPLAY_VIDEO_LABELS: 'sp_videoLabels',
    VOLUME_LEVEL: 'sp_volumeLevel',
    MUTE_SETTING: 'sp_muteSetting',
    AUDIO_INPUT_DEVICE: 'sp_audioInputDevice',
    AUDIO_OUTPUT_DEVICE: 'sp_audioOutputDevice'
  },
  HEADER_BAR: {
    HEIGHT: '60px',
  },
  VIDEO_SOURCES: {
    LIVE: 'live',
    RECORDED: 'recorded',
  },
  TRACK_NAMES: {
    CAMERA: 'camera',
    SCREEN_SHARE: 'screen-share',
    SECOND_CAMERA: 'second-camera',
  },
  RECORDING_STATUS: {
    COMPLETE: 'complete',
    LIVE: 'live',
  },
  LIVE_KIT: {
    REMOTE_PARTICIPANT: {
      CLASS_NAME: '_RemoteParticipant',
    },
    LOCAL_PARTICIPANT: {
      CLASS_NAME: 'LocalParticipant',
    },
  },
  OVERLAYS: {
    PLAYBACK_COVER: 'playbackCover',
    PLAYBACK_COMPLETE: 'playbackComplete',
    LIVE_LOADING_COVER: 'liveLoadingCover',
    BUFFERING: 'buffering',
    SESSION: {
      INITIALIZING: {
        NAME: 'initializing',
        TTL: 10000,
      },
      LOADING: {
        NAME: 'loading',
        TTL: 10000,
      },
      DISCONNECTED: {
        NAME: 'disconnected',
        TTL: 10000,
      },
      TRANSFERRED: {
        NAME: 'transferred',
        TTL: 10000,
      },
      ENDED: {
        NAME: 'ended',
        TTL: 10000,
      },
    }
  },
  PLAYER: {
    DEFAULT_SIDEBAR_PCT: 20,
    MIN_SIDEBAR_PCT: 20,
    MAX_SIDEBAR_PCT: 80,
    MARKER_DEFAULT_ROW_HEIGHT: 21,
    MARKER_ROW_HEIGHT: 5,
  },
  EVENT_TYPES: {
    RECORDING: {
      TRACK_CHANGED: 'RecordingTrackChanged',
    },
    ANNOTATIONS: {
      ADDED: 'AnnotationAdded',
      UPDATED: 'AnnotationUpdated',
      DELETED: 'AnnotationDeleted',
    },
    CHAT: {
      MESSAGE_ADDED: 'ChatMessageAdded',
      MESSAGE_DELETED: 'ChatMessageDeleted',
      MESSAGE_UPDATED: 'ChatMessageUpdated',
    }
  },
  ANNOTATIONS: {
    TYPES: {
      APPLY_MODALITY_OPTION: 'apply-modality-option',
      REMOVE_MODALITY_OPTION: 'remove-modality-option',
      START_REMOTE_CONTROL: 'remote-control-start',
      END_REMOTE_CONTROL: 'remote-control-end',
    },
    // The number of seconds that will be subtracted when clicking an annotation. This will allow the video to play into the annotation...
    SECONDS_LEADING_TO_ANNOTATION: 2,
  },
  STYLES: {
    CARD_HEADER_PADDING: 'none none none xx-small',
    CARD_BODY_PADDING: 'xx-small',
    CARD_BODY_TEXT_VARIANT: 'contentSmall',
    CARD_TITLE_PADDING: 'none none none xx-small',
    CARD_TITLE_VARIANT: 'contentSmall',
  },
  STATUSES : {
    CAN_HAVE_LIVE_VIDEO : ['in progress', 'testing', 'onboarding']
  },
  KEYBOARD_SHORTCUTS: {
    PLAYBACK:{
      TITLE: 'Playback',
      OPTIONS : {
        PAUSE: {
          KEY: 'space',
          DESCRIPTION: 'Pause/Play'
        },
        SEEK_BACKWARD_10_SECONDS: {
          KEY: 's+ArrowLeft',
          DESCRIPTION: 'Seek Backward 10 Seconds'
        },
        SEEK_FORWARD_10_SECONDS: {
          KEY: 's+ArrowRight',
          DESCRIPTION: 'Seek Forward 10 Seconds'
        },
        SLOW: {
          KEY: 's+0',
          DESCRIPTION: 'Set Playback Speed to 0.5x'
        },
        NORMAL: {
          KEY: 's+1',
          DESCRIPTION: 'Set Playback Speed to 1x'
        },
        FAST_2X: {
          KEY: 's+2',
          DESCRIPTION: 'Set Playback Speed to 2x'
        },
        FAST_5X: {
          KEY: 's+3',
          DESCRIPTION: 'Set Playback Speed to 5x'
        },
        FAST_10X: {
          KEY: 's+4',
          DESCRIPTION: 'Set Playback Speed to 10x'
        },
        FAST_16X: {
          KEY: 's+5',
          DESCRIPTION: 'Set Playback Speed to 16x'
        },
        SMART: {
          KEY: 's+`',
          DESCRIPTION: 'Set Playback Speed to Smart'
        },
      },
    },
    VIEW:{
      TITLE: 'View',
      OPTIONS : {
        TOGGLE_FULLSCREEN: {
          KEY: 'Alt+f',
          DESCRIPTION: 'Toggle Fullscreen'
        },
        TOGGLE_DETAILS: {
          KEY: 'Alt+d',
          DESCRIPTION: 'Toggle Details View'
        },
        VIDEO_LABELS:{
          TOGGLE: {
            KEY: 'd+l',
            DESCRIPTION: 'Toggle Video Labels'
          },
          SHOW: {
            KEY: 'd+l+s',
            DESCRIPTION: 'Show Video Labels'
          },
          HIDE: {
            KEY: 'd+l+h',
            DESCRIPTION: 'Hide Video Labels'
          },
        },
        RESET_VIDEO_STATE: {
          KEY: 'r',
          DESCRIPTION: 'Reset Video State'
        },
        HELP: {
          KEY: 'Ctrl+h',
          DESCRIPTION: 'Show Keyboard Shortcuts'
        },
        SESSION_LOG: {
          KEY: 'Ctrl+l',
          DESCRIPTION: 'Show Session Log'
        },
      },
    },
    VOLUME:{
      TITLE: 'Volume',
      OPTIONS : {
        MUTE: {
          KEY: 'Ctrl+m',
          DESCRIPTION: 'Mute/Unmute'
        },
      },
    },
    INCIDENT_REPORT:{
      TITLE: 'Incident Report',
      OPTIONS : {
        CREATE: {
          KEY: 'Ctrl+i',
          DESCRIPTION: 'Create Incident Report'
        },
        SUBMIT: {
          KEY: 'Meta+Shift+s',
          DESCRIPTION: 'Submit Incident Report'
        },
      },
    },
    ANNOTATIONS:{
        TITLE: 'Annotations',
        OPTIONS : {
          FLOATING_MODAL: {
            KEY: 'Ctrl+Shift+a',
            DESCRIPTION: 'Open Floating Annotations Dashboard'
          },
          ONLY_UNREVIEWED_TOGGGLE: {
            KEY: 'Shift+a+u',
            DESCRIPTION: 'Toggle Only Unreviewed'
          },
          SHOW_DETAILS: {
            KEY: 'Shift+a+d',
            DESCRIPTION: 'Toggle Details'
          },
        SHOW_REVIEWER_TOOLS: {
          KEY: 'Shift+a+t',
          DESCRIPTION: 'Toggle Reviewer Tools'
        },
        FLAGS: {
          KEY: 'Shift+a+f',
          DESCRIPTION: 'Toggle Flags'
        },
        EVENTS: {
          KEY: 'Shift+a+e',
          DESCRIPTION: 'Toggle Events'
        },
        PHASES: {
          KEY: 'Shift+a+p',
          DESCRIPTION: 'Toggle Phases'
        },
        CONNECTION: {
          KEY: 'Shift+a+c',
          DESCRIPTION: 'Toggle Connection'
        },
        NOTES: {
          KEY: 'Shift+a+n',
          DESCRIPTION: 'Toggle Notes'
        },
        BULK_EDIT:{
          TITLE: 'Bulk Edit',
          KEY: 'Shift+a+b',
          DESCRIPTION: 'Bulk Edit'
        },
        AUTO_SCROLL:{
          TITLE: 'Auto Scroll',
          KEY: 'Shift+a+s',
          DESCRIPTION: 'Auto Scroll'
        },
      },
    },
  },
};

export default CONSTANTS;
